import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Calendar, Heart, RefreshCw, Users, ShoppingCart } from 'lucide-react';

const StatCard = ({ label, value, Icon, valueColor = 'text-gray-900', testId }) => (
  <Card data-testid={testId}>
    <CardContent className="pt-6">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-sm font-medium text-gray-600">{label}</p>
          <p className={`text-3xl font-bold ${valueColor}`}>{value}</p>
        </div>
        <Icon className="w-12 h-12 text-[#FDB913]" />
      </div>
    </CardContent>
  </Card>
);

const StatsCards = ({ stats }) => (
  <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-6 mb-8">
    <StatCard label="Consultation Bookings" value={stats.totalBookings} Icon={Calendar} testId="stat-card-bookings" />
    <StatCard label="Wedding Bookings" value={stats.totalWeddings} Icon={Heart} testId="stat-card-weddings" />
    <StatCard label="Wine Orders" value={stats.totalOrders} Icon={ShoppingCart} testId="stat-card-orders" />
    <StatCard label="Pending" value={stats.pendingBookings} Icon={RefreshCw} valueColor="text-orange-600" testId="stat-card-pending" />
    <StatCard label="Newsletter Subscribers" value={stats.totalSubscribers} Icon={Users} testId="stat-card-subscribers" />
  </div>
);

export default StatsCards;
